import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getBookById, getAllDocumentTypes } from '../utils/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getFileUrl } from '../utils/api';

const ShopBook: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [book, setBook] = useState<any>(null);
  const [types, setTypes] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<'details' | 'images' | 'documents'>('details');

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      try {
        const b = await getBookById(id);
        setBook(b);
        const t = await getAllDocumentTypes();
        setTypes(t || []);
      } catch (e) {
        console.error(e);
      }
    };
    load();
  }, [id]);

  if (!book) return (
    <>
      <Header title="Book" />
      <div className="shop-container"><p>Loading...</p></div>
    </>
  );

  const groupedDocs = (book.documents || []).reduce((acc: any, doc: any) => {
    const key = doc.type || doc.documentType || 'other';
    if (!acc[key]) acc[key] = [];
    acc[key].push(doc);
    return acc;
  }, {} as Record<string, any[]>);

  return (
    <>
      <Header title={book.title || 'Book'} />
      <div className="shop-container book-details">
        <div className="details-grid">
          <div className="left">
            <div className="main-image">
              {book.mainImage ? (
                <a href={book.mainImage} target="_blank" rel="noreferrer">
                  <img src={book.mainImage} alt={book.title} />
                </a>
              ) : (
                <div className="no-image">No Image</div>
              )}
            </div>
            <div className="thumbs">
              {(book.additionalImages || []).map((p: string, i: number) => (
                <div key={i} className="thumb">
                  <a href={p} target="_blank" rel="noreferrer">
                    <img src={p} alt={`${book.title} ${i+1}`} />
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div className="right">
            <h2>{book.title}</h2>
            <p className="price">₹{book.cost}</p>
            <p className="desc">{book.description}</p>

            <div className="tabs">
              <button className={`tab ${activeTab === 'details' ? 'active' : ''}`} onClick={() => setActiveTab('details')}>Details</button>
              <button className={`tab ${activeTab === 'images' ? 'active' : ''}`} onClick={() => setActiveTab('images')}>Images</button>
              <button className={`tab ${activeTab === 'documents' ? 'active' : ''}`} onClick={() => setActiveTab('documents')}>Documents</button>
            </div>

            <div className="tab-panel">
              {activeTab === 'details' && (
                <div>
                  <h4>Book Details</h4>
                  <p><strong>Authors:</strong> {(book.authors || []).join(', ')}</p>
                  <p><strong>Publication:</strong> {book.publication}</p>
                  <p><strong>Pages:</strong> {book.pages}</p>
                </div>
              )}

              {activeTab === 'images' && (
                <div className="images-panel">
                  <h4>Images</h4>
                  <div className="images-grid">
                    {book.mainImage && <img src={book.mainImage} alt="main" />}
                    {(book.additionalImages || []).map((p: string, i: number) => (
                      <img key={i} src={p} alt={`additional-${i}`} />
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'documents' && (
                <div className="documents-panel">
                  <h4>Documents</h4>
                  {Object.keys(groupedDocs).length === 0 && <p>No documents</p>}
                  {Object.keys(groupedDocs).map((typeKey) => {
                    const label = (types.find((t) => t._id === typeKey) || { name: typeKey }).name;
                    return (
                      <details key={typeKey} className="doc-accordion">
                        <summary>{label} ({groupedDocs[typeKey].length})</summary>
                        <ul>
                          {groupedDocs[typeKey].map((d: any) => {
                            const file = getFileUrl(d.fileUrl || d.filePath || (d.fileName ? `/uploads/documents/${d.fileName}` : ''));
                            return (
                              <li key={d._id || d.id}>
                                <a href={file || '#'} target="_blank" rel="noreferrer">{d.title || 'Document'}</a>
                              </li>
                            );
                          })}
                        </ul>
                      </details>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ShopBook;
